export const VIEW_COLUMNS = {
  BRAND: {
    id: 'brand',
    label: 'Brand',
  },
  NOTES: {
    id: 'notes',
    label: 'Notes',
  },
  ORDER_ID: {
    id: 'order_id',
    label: 'Order ID',
  },
  PURCHASE_DATE: {
    id: 'purchase_date',
    label: 'Purchase Date',
  },
  RETURN_DATE: {
    id: 'return_date',
    label: 'Return Date',
  },
  PURCHASE_ORDER_NUMBER: {
    id: 'purchase_order_number',
    label: 'PO #',
  },
  QTY: {
    id: 'qty',
    label: 'Qty',
  },
  SALES_CHANNEL: {
    id: 'sales_channel',
    label: 'Sales Channel',
  },
  SALES_ORDER_NUMBER: {
    id: 'sales_order_number',
    label: 'SO #',
  },
  SKU: {
    id: 'sku',
    label: 'SKU',
  },
  SUPPLIER: {
    id: 'supplier',
    label: 'Supplier',
  },
  UPC: {
    id: 'upc',
    label: 'UPC',
  },
  REASON: {
    id: 'reason',
    label: 'Reason',
  },
  ACTION: {
    id: 'next_action',
    label: 'Next Action',
  }
};